/**
 * Contrat de campagne — catalogue front des 7 promesses.
 *
 * Les ids sont le contrat avec le moteur (PLEDGE_CATALOG côté Rust, qui
 * porte les mesures et les seuils). Ici : les textes des cartes de
 * l'écran « Qu'avez-vous promis pendant votre campagne ? ».
 */

export interface PledgeCard {
  id: string;
  label: string;
  /** Le slogan de campagne — ce que le candidat a martelé. */
  slogan: string;
  /** Ce que le pays mesurera. */
  measure: string;
}

export const PLEDGE_CARDS: PledgeCard[] = [
  {
    id: "pledge_inegalites",
    label: "Réduire les inégalités",
    slogan: "« La fracture entre les deux France, c'est fini. »",
    measure: "L'écart des revenus (indice de Gini) devra se resserrer.",
  },
  {
    id: "pledge_economie",
    label: "Relancer l'économie",
    slogan: "« Le travail d'abord — je rendrai ce pays prospère. »",
    measure: "Le chômage devra reculer nettement.",
  },
  {
    id: "pledge_ordre",
    label: "Rétablir l'ordre",
    slogan: "« Partout, pour tous : la sécurité, sans excuse. »",
    measure: "Le climat sécuritaire devra se redresser.",
  },
  {
    id: "pledge_climat",
    label: "Engager la transition climatique",
    slogan: "« Notre génération rendra la planète habitable. »",
    measure: "L'intensité carbone du pays devra baisser.",
  },
  {
    id: "pledge_souverainete",
    label: "Reconquérir l'indépendance énergétique",
    slogan: "« Plus jamais à la merci d'un robinet étranger. »",
    measure: "L'indépendance énergétique devra progresser.",
  },
  {
    id: "pledge_comptes",
    label: "Redresser les comptes publics",
    slogan: "« On ne lègue pas des dettes à ses enfants. »",
    measure: "Le ratio dette/PIB devra refluer.",
  },
  {
    id: "pledge_hexagone",
    label: "L'Hexagone d'abord",
    slogan: "« Les nôtres avant les autres — et Bruxelles à sa place. »",
    measure: "Votre cap souverainiste devra rester assumé, mois après mois.",
  },
];

/** Verdict lisible d'un progrès normalisé. */
export function pledgeVerdict(progress: number): {
  label: string;
  tone: "good" | "mid" | "bad";
} {
  if (progress >= 1.0) return { label: "en passe d'être tenue", tone: "good" };
  if (progress >= 0.0) return { label: "en cours, sans éclat", tone: "mid" };
  if (progress > -1.0) return { label: "à la peine", tone: "mid" };
  return { label: "en voie de trahison", tone: "bad" };
}
